__turbopack_context__.v({
  "className": "gamja_flower_80eaedd8-module__CXmSZq__className",
});
